const initial = {
  screens: [],
  totalScreens: 0,
  page: 0,
  limit: 0,
  pages: 0,
};
export const ScreenManagementAdReducer = (state = initial, action) => {
  switch (action.type) {
    case 'getScreens':
      console.log(action.payload);
      return {
        ...state,
        screens: action.payload.data,
        totalScreens: action.payload.pagination.total,
        page: action.payload.pagination.page,
        limit: action.payload.pagination.limit,
        pages: action.payload.pagination.pages,
      };
    default:
      return state;
  }
};
